import _Model from "./_Model";
import Protocol from './Protocol';
import Configuration from './Configuration';
import Device from "./Device";
import Validator from "./Validator";
import { configurationModuleType } from "../constants";

export default class IOIsland extends _Model {
  constructor(json) {
    super(json);
    this.slot = IOIsland.getMappedOrDefault(json, 'slot', 0, v => parseInt(v));
    this.protocol = IOIsland.getMappedOrDefault(json, 'protocol', null, data => new Protocol(data));
    this.configuration = IOIsland.getMappedOrDefault(json, 'configuration', null, data => new Configuration(data));
    this.modules = IOIsland.getMappedOrDefault(json, 'modules', [], data => (data || []).map(d => {
      const device = new Device(d || {});
      device.moduleType = configurationModuleType.io_module;
      return device;
    }));
    this.validator = IOIsland.getMappedOrDefault(json, 'validator', new Validator(), data => new Validator(data || {}));
  }

  getName() {
    return this.configuration.name;
  }

  hasValidationError() {
    return this.hasMasterValidationError() || this.hasConfigValidationError();
  }

  hasMasterValidationError() {
    return !this.validator.valid;
  }

  hasConfigValidationError() {
    return this.configuration.hasValidationError();
  }

  hasProtocolValidationError() {
    return this.hasMasterValidationError() && this.getFailedProtocolRules().length > 0;
  }

  getFailedProtocolRules() {
    return this.validator?.failedRules?.filter(rule => rule.constraintGroup === "protocol") || [];
  }
}
